import type { Brand } from 'types/brands'

import { flatBrands } from './flatBrands'
import { getBrandTranslationKeys } from './getBrandTranslationKeys'

export const matchBrandFromUrl = ({
	url,
	translate,
	brands,
}: {
	url: string
	translate: (key: string) => string
	brands: Brand[]
}): Brand | undefined => {
	const getBrandNameEncoded = (brand: Brand) =>
		encodeURIComponent(
			translate(
				getBrandTranslationKeys(brand.id)?.urlKey || ''
			).toLocaleLowerCase()
		)

	const partialMatchedBrands = flatBrands(brands).filter((brand) => {
		const brandName = getBrandNameEncoded(brand)

		if (!brandName) {
			return false
		}

		return !!brandName && url.toLocaleLowerCase().includes(brandName)
	})

	if (partialMatchedBrands.length === 0) {
		return
	}

	const matchedBrand = partialMatchedBrands.reduce((largerBrand, currBrand) => {
		const largerBrandName = getBrandNameEncoded(largerBrand)
		const currBrandName = getBrandNameEncoded(currBrand)

		if (!largerBrandName || currBrandName.length > largerBrandName.length) {
			return currBrand
		}

		return largerBrand
	}, partialMatchedBrands[0])

	if (matchedBrand?.subBrands) {
		const matchedSubBrand = matchBrandFromUrl({
			url,
			translate,
			brands: matchedBrand.subBrands,
		})

		return matchedSubBrand || matchedBrand
	}

	return matchedBrand
}
